import Vue from 'vue'
import VueObserveVisibility from 'vue-observe-visibility'

Vue.use(VueObserveVisibility)
export default VueObserveVisibility



// WEBPACK FOOTER //
// ./src/plugins/visibleObserver.js